import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'

import { getReport } from '../helpers'
import request from 'Request'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import Section from 'Components/Section'
import DoctorReport from './components/DoctorActivityReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default () => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reportSets, setReportSets] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    const newReportSet = await request('/info/app-codes/list').then(res =>
      res.data.map(appCode => ({ appCode, reports: [] }))
    )
    const requests = []
    for (const reportSet of newReportSet) {
      requests.push(
        getReport('/reports/activity/get', {
          appCode: reportSet.appCode,
          startDate,
          endDate,
          showArchivedOffices
        }).then(reports => (reportSet.reports = reports))
      )
    }
    await Promise.all(requests)
    setReportSets(newReportSet)
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`Cluster Activity Report`}
        csvUrl="/reports/activity/csv"
        csvPayload={reportSortingState}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reportSets.map(reportSet => (
        <>
          <ReportHeader
            header="App Code"
            title={reportSet.appCode}
            cardValues={[]}
          ></ReportHeader>
          {reportSet.reports.map(report => (
            <>
              <ReportHeader
                header="Office"
                title={report.title}
                cardValues={[
                  ['Total', 'Patients', report.totalPatients],
                  ['Total Active', 'Patients', report.totalActivePatients],
                  [
                    'Total Not Started',
                    'Patients',
                    report.totalInactivePatients
                  ],
                  ['Total New Active', 'Patients', report.totalNewPatients],
                  ['Total Reported', 'Alerts', report.flags]
                ]}
              />
              <ReportHeader
                header=""
                title=""
                cardValues={Object.keys(
                  report.totalPatientByGroup
                ).map(item => [
                  'Group: ' + item,
                  'Patients',
                  report.totalPatientByGroup[item]
                ])}
              />
              {Object.values(report.doctorsByGroup).length === 0 && (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '16px 0',
                    margin: '16px 0',
                    borderBottom: `1px solid ${colors.borderColor}`
                  }}
                >
                  There are no items in this office
                </div>
              )}
              {Object.keys(report.doctorsByGroup).map(group => {
                return (
                  <>
                    <div
                      style={{
                        padding: '10px 5px',
                        backgroundColor: `${colors.activity}`,
                        color: `${colors.textOnPrimary}`
                      }}
                    >
                      <Section header="Group" title={group} />
                    </div>
                    {Object.values(report.doctorsByGroup[group]).map(doctor => (
                      <DoctorReport doctor={doctor} />
                    ))}
                  </>
                )
              })}
            </>
          ))}
        </>
      ))}
    </>
  )
}
